import { AbstractRoomCommand } from "./AbstractRoomCommand";
export class EditWallOpening extends AbstractRoomCommand {
    constructor(pRoomManager, pOpening) {
        super(pRoomManager);
        this.mOpening = pOpening;
        this.mUndoData = this.mOpening._saveUndoData();
    }
    isUndoable() {
        return (true);
    }
    execute(pParameter) {
        this.mRedoData = this.mOpening._saveUndoData();
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve(true));
    }
    cancel() {
        this.undo();
    }
    undo() {
        this.mOpening._loadUndoData(this.mUndoData);
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve());
    }
    redo() {
        this.mOpening._loadUndoData(this.mRedoData);
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve());
    }
}
